export default "__VITE_ASSET__751624ea__"